import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home as HomeIcon } from "lucide-react";

export default function NotFound() {
  return (
    <div
      data-testid="notfound-page"
      className="mx-auto flex max-w-6xl flex-col items-center justify-center px-4 py-28 text-center sm:px-6 lg:px-8"
    >
      <p className="text-6xl font-bold text-halalgo-green-700">404</p>
      <h1 className="mt-4 text-2xl font-bold tracking-tight text-halalgo-ink sm:text-3xl">
        Page not found
      </h1>
      <p className="mt-3 max-w-md text-halalgo-ink/70">
        The page you're looking for doesn't exist or has moved. Let's get you back
        to something delicious.
      </p>
      <Button
        asChild
        className="mt-8 h-11 bg-halalgo-green-600 px-5 text-white shadow-lift-sm hover:bg-halalgo-green-700 active:scale-[0.98]"
        data-testid="notfound-home-button"
      >
        <Link to="/">
          <HomeIcon className="h-4 w-4" /> Back to home
        </Link>
      </Button>
    </div>
  );
}
